import { createResourceRequests } from '../../helpers/resource';
import * as normalizers from './normalizers';

const getSurvey = () => ({
  method: 'GET',
  url: 'api/survey/1',
  normalizer: normalizers.getSurvey,
});

const postSurvey = (props) => ({
  method: 'POST',
  url: 'api/survey/1',
  data: normalizers.postSurvey(props),
});


const endpoints = {
  getSurvey,
  postSurvey,
};

const api = createResourceRequests(endpoints);

export default api;



// WEBPACK FOOTER //
// ./src/resources/tara/api.js